import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ref, get } from 'firebase/database'
import { db, tref } from '../../lib/firebase.js'

const ACCENT = 'var(--ge-primary)'

// Universal search — one box across members, products, repairs, gift cards,
// and special orders. Loads the nodes lazily on first focus (one get each),
// then filters client-side. Results link straight to the owning module.
export default function GUniversalSearch() {
  const [q, setQ] = useState('')
  const [data, setData] = useState(null) // null = not loaded
  const [open, setOpen] = useState(false)

  const load = async () => {
    if (data) return
    const [members, products, repairs, credit, orders] = await Promise.all(
      ['club/members', 'club/products', 'club/repairs', 'club/proShopCredit', 'club/specialOrders'].map((p) => get(tref(p)).then((s) => s.val() || {}))
    )
    setData({ members, products, repairs, giftCards: credit.giftCards || {}, orders })
  }

  const results = (() => {
    const s = q.trim().toLowerCase()
    if (!s || !data) return []
    const out = []
    Object.values(data.members).filter(Boolean).forEach((m) => { if (`${m.name} ${m.memberNumber || ''} ${m.phone || ''} ${m.email || ''}`.toLowerCase().includes(s)) out.push({ icon: '👥', label: m.name, sub: 'Member', to: `/admin/gg/members/${m.id}` }) })
    Object.values(data.products).filter(Boolean).forEach((p) => { if (`${p.name} ${p.sku} ${p.barcode} ${p.brand}`.toLowerCase().includes(s)) out.push({ icon: '🏷️', label: p.name || p.sku, sub: `Product · ${p.quantity ?? 0} in stock`, to: '/admin/gg/inventory' }) })
    Object.values(data.repairs).filter(Boolean).forEach((r) => { if (`${r.club} ${r.manufacturer} ${r.repairRequested}`.toLowerCase().includes(s)) out.push({ icon: '🔧', label: r.club, sub: `Repair · ${r.status}`, to: '/admin/gg/repairs' }) })
    Object.values(data.giftCards).filter(Boolean).forEach((c) => { if (`${c.code} ${c.recipient || ''}`.toLowerCase().includes(s)) out.push({ icon: '💳', label: c.code, sub: 'Gift card', to: '/admin/pro-shop-credit' }) })
    Object.values(data.orders).filter(Boolean).forEach((o) => { if (`${o.name} ${o.item} ${o.vendor || ''}`.toLowerCase().includes(s)) out.push({ icon: '📦', label: o.item, sub: `Order · ${o.status}`, to: '/admin/special-orders' }) })
    return out.slice(0, 12)
  })()

  return (
    <div className="relative">
      <input
        className="input w-full" placeholder="Search"
        value={q} onFocus={() => { load(); setOpen(true) }} onBlur={() => setTimeout(() => setOpen(false), 150)}
        onChange={(e) => setQ(e.target.value)}
      />
      {open && q.trim() ? (
        <div className="absolute z-40 mt-1 w-full rounded-xl bg-white shadow-xl max-h-80 overflow-y-auto" style={{ border: `1px solid ${ACCENT}55` }}>
          {results.length === 0 ? <div className="px-3 py-2 text-sm text-gray-400">{data ? 'No matches.' : 'Loading…'}</div> : results.map((r, i) => (
            <Link key={i} to={r.to} onClick={() => setOpen(false)} className="flex items-center gap-2 px-3 py-2 hover:bg-gray-50 border-b" style={{ borderColor: 'rgba(0,0,0,0.05)' }}>
              <span>{r.icon}</span><span className="font-bold text-sm" style={{ color: 'var(--ge-primary)' }}>{r.label}</span><span className="text-xs text-gray-400 ml-auto">{r.sub}</span>
            </Link>
          ))}
        </div>
      ) : null}
    </div>
  )
}
